import { render, staticRenderFns } from "./InputName.vue?vue&type=template&id=0c0b2f08&scoped=true&"
import script from "./InputName.vue?vue&type=script&lang=js&"
export * from "./InputName.vue?vue&type=script&lang=js&"
import style0 from "./InputName.vue?vue&type=style&index=0&id=0c0b2f08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0b2f08",
  null
  
)

export default component.exports